/*
         * @ngdoc function
         * @name ePay.WebApi:FormWebApi
         * @description
         * Web Api Service
         */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Session_ePaySessionModel } from '../../Models/Model/Session_ePaySessionModel';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormWebApi {
  constructor(private http: HttpClient) { }


	session_Live(sessionId?: string, iFrame?: boolean) {
		let _formdata = new FormData();
		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');
		let urlParams = new HttpParams();
		if (sessionId !== null && typeof sessionId !== 'undefined')
		{
			urlParams = urlParams.append('sessionId', sessionId.toString());
		}
		if (iFrame !== null && typeof iFrame !== 'undefined')
		{
			urlParams = urlParams.append('iFrame', iFrame.toString());
		}
		return this.http.post<Session_ePaySessionModel>('/api/Form/Session_Live', _formdata, {headers: headers, params: urlParams})
	}

  deviceConnect(session_ePaySession: Session_ePaySessionModel, hsn: string | null) {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    let params = new HttpParams();

    if (hsn != null) {
      params = params.append('hsn', hsn);
    }
    console.log('connect to HSN',hsn)
    return this.http.post<Session_ePaySessionModel>('/api/Session_ePaySession/DeviceConnect', session_ePaySession, { headers, params });
  }

  deviceCharge(session_ePaySession: Session_ePaySessionModel): Observable<Session_ePaySessionModel> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    const params = new HttpParams();

    return this.http.post<Session_ePaySessionModel>('/api/Session_ePaySession/DeviceCharge', session_ePaySession, { headers, params });
  }


  manualCharge(session_ePaySession: Session_ePaySessionModel) {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    const params = new HttpParams();

    return this.http.post<Session_ePaySessionModel>('/api/Session_ePaySession/ManualCharge', session_ePaySession, { headers, params });
  }

  deviceCancelRequest(session_ePaySession: Session_ePaySessionModel) {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    const params = new HttpParams();

    console.info('posting to device Charge');
    return this.http.post<Session_ePaySessionModel>('/api/Session_ePaySession/DeviceCancelRequest', session_ePaySession, { headers, params });
  }

}
